var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticStyle: {
        height: "100%",
        "overflow-y": "hidden",
        width: "100%",
        "border-left": "1px solid #E6E6E6",
      },
    },
    [
      _c(
        "el-tooltip",
        { attrs: { content: _vm.$t("chart.draw_back") } },
        [
          _c("el-button", {
            staticClass: "el-icon-d-arrow-right",
            staticStyle: {
              position: "absolute",
              left: "4px",
              top: "5px",
              "z-index": "1",
            },
            attrs: { size: "mini", circle: "" },
            on: { click: _vm.closePanelEdit },
          }),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "padding-lr", staticStyle: { height: "40px" } },
        [
          _c(
            "el-popover",
            {
              attrs: {
                placement: "right-start",
                width: "400",
                trigger: "click",
              },
              on: { show: _vm.showTab, hide: _vm.hideTab },
            },
            [
              _c("dataset-chart-detail", {
                attrs: {
                  type: "chart",
                  data: _vm.view,
                  "tab-status": _vm.tabStatus,
                },
              }),
              _c("svg-icon", {
                staticClass: "icon-class",
                staticStyle: {
                  position: "absolute",
                  "margin-left": "30px",
                  top: "14px",
                  cursor: "pointer",
                },
                attrs: { slot: "reference", "icon-class": "icon_info_filled" },
                slot: "reference",
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "title-text view-title-name",
              staticStyle: { "line-height": "40px" },
            },
            [_vm._v(_vm._s(_vm.view.name))]
          ),
          _c(
            "span",
            { staticStyle: { float: "right", "line-height": "40px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "", size: "mini", disabled: !_vm.hasEdit },
                  on: { click: _vm.reset },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("chart.recover")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "view-panel-row" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "tab-header",
              attrs: { stretch: true },
              model: {
                value: _vm.tabActive,
                callback: function ($$v) {
                  _vm.tabActive = $$v
                },
                expression: "tabActive",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  staticClass: "padding-tab",
                  staticStyle: { width: "350px" },
                  attrs: { name: "data", label: _vm.$t("chart.chart_data") },
                },
                [
                  _vm.view.dataFrom === "template"
                    ? _c("div", { staticClass: "view-panel-Mask" }, [
                        _c(
                          "span",
                          { staticStyle: { opacity: "1" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { opacity: "1!important" },
                                attrs: {
                                  type: "warning",
                                  title: _vm.$t("chart.change_ds"),
                                  size: "mini",
                                  round: "",
                                },
                                on: { click: _vm.changeDs },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("panel.template_view_tips"))
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-refresh el-icon--right",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "el-row",
                    { staticClass: "view-panel" },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "theme-border-class",
                          staticStyle: { "border-right": "1px solid #E6E6E6" },
                          attrs: { span: 11 },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "center",
                                padding: "6px",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "main-area-input",
                                attrs: {
                                  size: "mini",
                                  placeholder: _vm.$t("chart.search"),
                                  "prefix-icon": "el-icon-search",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchField,
                                  callback: function ($$v) {
                                    _vm.searchField = $$v
                                  },
                                  expression: "searchField",
                                },
                              }),
                              _c(
                                "el-dropdown",
                                {
                                  attrs: { trigger: "click", size: "mini" },
                                  on: { command: _vm.fieldEdit },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link" },
                                    [
                                      _c("el-button", {
                                        staticStyle: {
                                          float: "right",
                                          width: "20px",
                                          "margin-left": "4px",
                                        },
                                        attrs: {
                                          title: _vm.$t("dataset.field_manage"),
                                          icon: "el-icon-setting",
                                          type: "text",
                                          size: "mini",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            disabled:
                                              !_vm.table ||
                                              !_vm.hasDataPermission(
                                                "manage",
                                                _vm.table.privileges
                                              ),
                                            command: _vm.beforeFieldEdit("ds"),
                                            icon: "el-icon-s-grid",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("chart.ds_field_edit")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command:
                                              _vm.beforeFieldEdit("chart"),
                                            icon: "el-icon-s-data",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("chart.chart_field_edit")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("el-button", {
                                staticStyle: {
                                  float: "right",
                                  width: "20px",
                                  "margin-left": "4px",
                                },
                                attrs: {
                                  title: _vm.$t("chart.change_ds"),
                                  icon: "el-icon-refresh",
                                  type: "text",
                                  size: "mini",
                                },
                                on: { click: _vm.changeDs },
                              }),
                            ],
                            1
                          ),
                          _vm.fieldShow && _vm.tabActive === "data"
                            ? _c(
                                "div",
                                { staticClass: "field-split" },
                                [
                                  _c("fu-split-pane", {
                                    attrs: {
                                      top: "50%",
                                      direction: "vertical",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "top",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "padding-lr field-height",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "chart.dimension"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm.table &&
                                                  _vm.hasDataPermission(
                                                    "use",
                                                    _vm.table.privileges
                                                  )
                                                    ? _c(
                                                        "draggable",
                                                        {
                                                          staticClass:
                                                            "drag-list",
                                                          attrs: {
                                                            options: {
                                                              group: {
                                                                name: "drag",
                                                                pull: "clone",
                                                              },
                                                              sort: true,
                                                            },
                                                            animation: "300",
                                                            move: _vm.onMove,
                                                          },
                                                          on: {
                                                            add: _vm.moveToDimension,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.dimensionData,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.dimensionData =
                                                                $$v
                                                            },
                                                            expression:
                                                              "dimensionData",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "transition-group",
                                                            _vm._l(
                                                              _vm.dimensionData,
                                                              function (item) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key: item.id,
                                                                    staticClass:
                                                                      "item-dimension father",
                                                                    attrs: {
                                                                      title:
                                                                        item.name,
                                                                    },
                                                                  },
                                                                  [
                                                                    item.deType ===
                                                                    0
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-text",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_text",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deType ===
                                                                    1
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-time",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_time",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deType ===
                                                                      2 ||
                                                                    item.deType ===
                                                                      3
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-value",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_value",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deType ===
                                                                    5
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-location",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_location",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "field-name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "el-dropdown",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value: false,
                                                                              expression:
                                                                                "false",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "field-setting child",
                                                                        attrs: {
                                                                          placement:
                                                                            "right-start",
                                                                          trigger:
                                                                            "click",
                                                                          size: "mini",
                                                                        },
                                                                        on: {
                                                                          command:
                                                                            _vm.chartFieldEdit,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "el-dropdown-link",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "el-icon-s-tools",
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-dropdown-menu",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                slot: "dropdown",
                                                                              },
                                                                            slot: "dropdown",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "el-dropdown-item",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    command:
                                                                                      _vm.handleChartFieldEdit(
                                                                                        item,
                                                                                        "copy"
                                                                                      ),
                                                                                    icon: "el-icon-document-copy",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "commons.copy"
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            item.chartId
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _c(
                                                                                      "el-dropdown-item",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            command:
                                                                                              _vm.handleChartFieldEdit(
                                                                                                item,
                                                                                                "edit"
                                                                                              ),
                                                                                            icon: "el-icon-edit",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "commons.edit"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "el-dropdown-item",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            command:
                                                                                              _vm.handleChartFieldEdit(
                                                                                                item,
                                                                                                "delete"
                                                                                              ),
                                                                                            icon: "el-icon-delete",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "commons.delete"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _vm._e(),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "bottom",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "padding-lr field-height",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("chart.quota")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm.table &&
                                                  _vm.hasDataPermission(
                                                    "use",
                                                    _vm.table.privileges
                                                  )
                                                    ? _c(
                                                        "draggable",
                                                        {
                                                          staticClass:
                                                            "drag-list",
                                                          attrs: {
                                                            options: {
                                                              group: {
                                                                name: "drag",
                                                                pull: "clone",
                                                              },
                                                              sort: true,
                                                            },
                                                            animation: "300",
                                                            move: _vm.onMove,
                                                          },
                                                          on: {
                                                            add: _vm.moveToQuota,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.quotaData,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.quotaData =
                                                                $$v
                                                            },
                                                            expression:
                                                              "quotaData",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "transition-group",
                                                            _vm._l(
                                                              _vm.quotaData,
                                                              function (item) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm
                                                                              .chart
                                                                              .type &&
                                                                            (_vm
                                                                              .chart
                                                                              .type !==
                                                                              "table-info" ||
                                                                              (_vm
                                                                                .chart
                                                                                .type ===
                                                                                "table-info" &&
                                                                                item.id !==
                                                                                  "count")),
                                                                          expression:
                                                                            "chart.type && (chart.type !== 'table-info' || (chart.type === 'table-info' && item.id !=='count'))",
                                                                        },
                                                                      ],
                                                                    key: item.id,
                                                                    staticClass:
                                                                      "item-quota father",
                                                                    attrs: {
                                                                      title:
                                                                        item.name,
                                                                    },
                                                                  },
                                                                  [
                                                                    item.deType ===
                                                                    0
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-text",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_text",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deType ===
                                                                    1
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-time",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_time",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deType ===
                                                                      2 ||
                                                                    item.deType ===
                                                                      3
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-value",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_value",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deType ===
                                                                    5
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-location",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_location",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "field-name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    item.id !==
                                                                    "count"
                                                                      ? _c(
                                                                          "el-dropdown",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value: false,
                                                                                  expression:
                                                                                    "false",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "field-setting child",
                                                                            attrs:
                                                                              {
                                                                                placement:
                                                                                  "right-start",
                                                                                trigger:
                                                                                  "click",
                                                                                size: "mini",
                                                                              },
                                                                            on: {
                                                                              command:
                                                                                _vm.chartFieldEdit,
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "el-dropdown-link",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "el-icon-s-tools",
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "el-dropdown-menu",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    slot: "dropdown",
                                                                                  },
                                                                                slot: "dropdown",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "el-dropdown-item",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        command:
                                                                                          _vm.handleChartFieldEdit(
                                                                                            item,
                                                                                            "copy"
                                                                                          ),
                                                                                        icon: "el-icon-document-copy",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "commons.copy"
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                item.chartId
                                                                                  ? _c(
                                                                                      "span",
                                                                                      [
                                                                                        _c(
                                                                                          "el-dropdown-item",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                command:
                                                                                                  _vm.handleChartFieldEdit(
                                                                                                    item,
                                                                                                    "edit"
                                                                                                  ),
                                                                                                icon: "el-icon-edit",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "commons.edit"
                                                                                                )
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                        _c(
                                                                                          "el-dropdown-item",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                command:
                                                                                                  _vm.handleChartFieldEdit(
                                                                                                    item,
                                                                                                    "delete"
                                                                                                  ),
                                                                                                icon: "el-icon-delete",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "commons.delete"
                                                                                                )
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2726606961
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "theme-border-class",
                          staticStyle: {
                            height: "100%",
                            "border-right": "1px solid #E6E6E6",
                          },
                          attrs: { span: 13 },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "padding-lr theme-border-class",
                              staticStyle: { height: "60px", overflow: "auto" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "theme-border-class" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chart.chart_type"))),
                                  ]),
                                  _c(
                                    "el-row",
                                    {
                                      staticStyle: {
                                        padding: "4px 0 4px 10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _c("svg-icon", {
                                            staticClass: "chart-icon",
                                            attrs: {
                                              "icon-class":
                                                _vm.view.isPlugin &&
                                                _vm.view.type &&
                                                _vm.view.type !== "buddle-map"
                                                  ? "/api/pluginCommon/staticInfo/" +
                                                    _vm.view.type +
                                                    "/svg"
                                                  : _vm.view.type,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { float: "right" } },
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "bottom-end",
                                                width: "400",
                                                trigger: "click",
                                                "append-to-body": true,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "padding-lr" },
                                                [
                                                  _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "theme-border-class",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.chart_type"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          float: "right",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "render-select",
                                                            staticStyle: {
                                                              width: "100px",
                                                            },
                                                            attrs: {
                                                              size: "mini",
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.changeChartRender()
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.view.render,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.view,
                                                                    "render",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "view.render",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.pluginRenderOptions,
                                                            function (item) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: item.value,
                                                                  attrs: {
                                                                    value:
                                                                      item.value,
                                                                    label:
                                                                      item.name,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]),
                                                  _c("el-row", [
                                                    _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "el-radio-group",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.changeChartType()
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.view.type,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.view,
                                                                    "type",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "view.type",
                                                            },
                                                          },
                                                          [
                                                            _c("chart-type", {
                                                              ref: "cu-chart-type",
                                                              staticStyle: {
                                                                height: "480px",
                                                              },
                                                              attrs: {
                                                                chart: _vm.view,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    padding: "6px",
                                                  },
                                                  attrs: {
                                                    slot: "reference",
                                                    size: "mini",
                                                  },
                                                  slot: "reference",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "chart.change_chart_type"
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-caret-bottom",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "attr-style theme-border-class",
                              staticStyle: {
                                overflow: "auto",
                                "border-top": "1px solid #e6e6e6",
                              },
                            },
                            [
                              _c(
                                "el-row",
                                { staticStyle: { height: "100%" } },
                                [
                                  _c(
                                    "el-row",
                                    { staticClass: "padding-lr" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.view.type ===
                                                "richTextView",
                                              expression:
                                                "view.type==='richTextView'",
                                            },
                                          ],
                                          staticStyle: {
                                            color: "#909399",
                                            "font-size": "8px",
                                            width: "80px",
                                            "text-align": "right",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Tips:" +
                                              _vm._s(
                                                _vm.$t(
                                                  "chart.rich_text_view_result_tips"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.view.type !==
                                                "richTextView",
                                              expression:
                                                "view.type!=='richTextView'",
                                            },
                                          ],
                                          staticStyle: {
                                            width: "80px",
                                            "text-align": "right",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("chart.result_count")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-row",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.view.type !==
                                                "richTextView",
                                              expression:
                                                "view.type!=='richTextView'",
                                            },
                                          ],
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              staticClass: "radio-span",
                                              attrs: { size: "mini" },
                                              on: { change: _vm.calcData },
                                              model: {
                                                value: _vm.view.resultMode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.view,
                                                    "resultMode",
                                                    $$v
                                                  )
                                                },
                                                expression: "view.resultMode",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "all" } },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "chart.result_mode_all"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "custom" } },
                                                [
                                                  _c("el-input", {
                                                    staticClass: "result-count",
                                                    attrs: { size: "mini" },
                                                    on: {
                                                      change: _vm.calcData,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.view.resultCount,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.view,
                                                          "resultCount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "view.resultCount",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { staticClass: "padding-lr" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            width: "80px",
                                            "text-align": "right",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "panel.refresh_frequency"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "bottom",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "chart.chart_refresh_tips"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-info",
                                            staticStyle: {
                                              cursor: "pointer",
                                              color: "#606266",
                                              "font-size": "12px",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "padding-lr" },
                                        [
                                          _c("el-checkbox", {
                                            staticClass:
                                              "el-input-refresh-loading",
                                            on: {
                                              change: _vm.refreshAttrChange,
                                            },
                                            model: {
                                              value: _vm.view.refreshViewEnable,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.view,
                                                  "refreshViewEnable",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "view.refreshViewEnable",
                                            },
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "panel.enable_refresh_view"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "el-input-refresh-time",
                                            attrs: {
                                              type: "number",
                                              size: "mini",
                                              "controls-position": "right",
                                              min: 1,
                                              max: 3600,
                                              disabled:
                                                !_vm.view.refreshViewEnable,
                                            },
                                            on: {
                                              change: _vm.refreshAttrChange,
                                            },
                                            model: {
                                              value: _vm.view.refreshTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.view,
                                                  "refreshTime",
                                                  $$v
                                                )
                                              },
                                              expression: "view.refreshTime",
                                            },
                                          }),
                                          _c(
                                            "el-select",
                                            {
                                              staticClass:
                                                "el-input-refresh-unit margin-left8",
                                              attrs: {
                                                size: "mini",
                                                disabled:
                                                  !_vm.view.refreshViewEnable,
                                              },
                                              on: {
                                                change: _vm.refreshAttrChange,
                                              },
                                              model: {
                                                value: _vm.view.refreshUnit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.view,
                                                    "refreshUnit",
                                                    $$v
                                                  )
                                                },
                                                expression: "view.refreshUnit",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: _vm.$t("panel.minute"),
                                                  value: "minute",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: _vm.$t("panel.second"),
                                                  value: "second",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.view.isPlugin
                                    ? _c("plugin-com", {
                                        attrs: {
                                          "component-name":
                                            _vm.view.type + "-data",
                                          obj: {
                                            view: _vm.view,
                                            param: _vm.param,
                                            chart: _vm.chart,
                                            dimensionData: _vm.dimensionData,
                                            quotaData: _vm.quotaData,
                                          },
                                        },
                                      })
                                    : _c(
                                        "div",
                                        [
                                          _vm.view.type === "map"
                                            ? _c(
                                                "el-row",
                                                { staticClass: "padding-lr" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        width: "80px",
                                                        "text-align": "right",
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.map_range"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tree-select-span",
                                                    },
                                                    [
                                                      _c("treeselect", {
                                                        ref: "mapSelector",
                                                        attrs: {
                                                          options: _vm.places,
                                                          placeholder: _vm.$t(
                                                            "chart.select_map_range"
                                                          ),
                                                          normalizer:
                                                            _vm.normalizer,
                                                          "no-children-text":
                                                            _vm.$t(
                                                              "commons.treeselect.no_children_text"
                                                            ),
                                                          "no-options-text":
                                                            _vm.$t(
                                                              "commons.treeselect.no_options_text"
                                                            ),
                                                          "no-results-text":
                                                            _vm.$t(
                                                              "commons.treeselect.no_results_text"
                                                            ),
                                                        },
                                                        on: {
                                                          input: _vm.calcData,
                                                          deselect:
                                                            _vm.calcData,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.view.customAttr
                                                              .areaCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.view
                                                                .customAttr,
                                                              "areaCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "view.customAttr.areaCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.view.type === "table-pivot"
                                            ? _c(
                                                "el-row",
                                                { staticClass: "padding-lr" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "data-area-label",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.table_pivot_row"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        "\n                      /\n                      "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.dimension"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-down el-icon-delete data-area-clear",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clearData(
                                                              "xaxisExt"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "draggable",
                                                    {
                                                      staticClass:
                                                        "drag-block-style",
                                                      attrs: {
                                                        group: "drag",
                                                        animation: "300",
                                                        move: _vm.onMove,
                                                      },
                                                      on: {
                                                        add: _vm.addXaxisExt,
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.calcData(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.view.xaxisExt,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.view,
                                                            "xaxisExt",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "view.xaxisExt",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticClass:
                                                            "draggable-group",
                                                        },
                                                        _vm._l(
                                                          _vm.view.xaxisExt,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "dimension-ext-item",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  param:
                                                                    _vm.param,
                                                                  index: index,
                                                                  item: item,
                                                                  "dimension-data":
                                                                    _vm.dimension,
                                                                  "quota-data":
                                                                    _vm.quota,
                                                                  chart:
                                                                    _vm.chart,
                                                                },
                                                                on: {
                                                                  onDimensionItemChange:
                                                                    _vm.dimensionItemChange,
                                                                  onDimensionItemRemove:
                                                                    _vm.dimensionItemRemove,
                                                                  editItemFilter:
                                                                    _vm.showDimensionEditFilter,
                                                                  onNameEdit:
                                                                    _vm.showRename,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.view.xaxisExt ||
                                                  _vm.view.xaxisExt.length === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "drag-placeholder-style-span",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "chart.placeholder_field"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.view.type !== "text" &&
                                          _vm.view.type !== "gauge" &&
                                          _vm.view.type !== "liquid"
                                            ? _c(
                                                "el-row",
                                                { staticClass: "padding-lr" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "data-area-label",
                                                    },
                                                    [
                                                      _vm.view.type &&
                                                      _vm.view.type.includes(
                                                        "table"
                                                      )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_table_data_column"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          (_vm.view.type.includes(
                                                            "bar"
                                                          ) ||
                                                            _vm.view.type.includes(
                                                              "line"
                                                            ) ||
                                                            _vm.view.type.includes(
                                                              "scatter"
                                                            ) ||
                                                            _vm.view.type ===
                                                              "chart-mix" ||
                                                            _vm.view.type ===
                                                              "waterfall" ||
                                                            _vm.view.type ===
                                                              "area")
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_type_axis"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "pie"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_pie_label"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "funnel"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_funnel_split"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "radar"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_radar_label"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type ===
                                                            "map"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.area"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "treemap"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_treemap_label"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type ===
                                                            "word-cloud"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_word_cloud_label"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type ===
                                                            "label"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_label"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.view
                                                                  .type !==
                                                                "richTextView",
                                                              expression:
                                                                "view.type !== 'richTextView'",
                                                            },
                                                          ],
                                                        },
                                                        [_vm._v(" / ")]
                                                      ),
                                                      _vm.view.type &&
                                                      _vm.view.type !==
                                                        "table-info"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.dimension"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type ===
                                                            "table-info"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.dimension_or_quota"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-down el-icon-delete data-area-clear",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clearData(
                                                              "xaxis"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "draggable",
                                                    {
                                                      staticClass:
                                                        "drag-block-style",
                                                      attrs: {
                                                        group: "drag",
                                                        animation: "300",
                                                        move: _vm.onMove,
                                                      },
                                                      on: {
                                                        add: _vm.addXaxis,
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.calcData(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: _vm.view.xaxis,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.view,
                                                            "xaxis",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "view.xaxis",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticClass:
                                                            "draggable-group",
                                                        },
                                                        _vm._l(
                                                          _vm.view.xaxis,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "dimension-item",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  param:
                                                                    _vm.param,
                                                                  index: index,
                                                                  item: item,
                                                                  "dimension-data":
                                                                    _vm.dimension,
                                                                  "quota-data":
                                                                    _vm.quota,
                                                                  chart:
                                                                    _vm.chart,
                                                                },
                                                                on: {
                                                                  onDimensionItemChange:
                                                                    _vm.dimensionItemChange,
                                                                  onDimensionItemRemove:
                                                                    _vm.dimensionItemRemove,
                                                                  editItemFilter:
                                                                    _vm.showDimensionEditFilter,
                                                                  onNameEdit:
                                                                    _vm.showRename,
                                                                  valueFormatter:
                                                                    _vm.valueFormatter,
                                                                  onCustomSort:
                                                                    _vm.onCustomSort,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.view.xaxis ||
                                                  _vm.view.xaxis.length === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "drag-placeholder-style-span",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "chart.placeholder_field"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.view.type === "bar-group" ||
                                          _vm.view.type === "bar-group-stack" ||
                                          (_vm.view.render === "antv" &&
                                            _vm.view.type === "line")
                                            ? _c(
                                                "el-row",
                                                { staticClass: "padding-lr" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "data-area-label",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "chart.chart_group"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.view
                                                                    .type !==
                                                                  "line",
                                                                expression:
                                                                  "view.type !== 'line'",
                                                              },
                                                            ],
                                                            staticStyle: {
                                                              color: "#F54A45",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        "\n                      /\n                      "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.dimension"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.view
                                                                  .type !==
                                                                "line",
                                                              expression:
                                                                "view.type !== 'line'",
                                                            },
                                                          ],
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            placement: "bottom",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "content",
                                                              },
                                                              slot: "content",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "chart.sub_dimension_tip"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-info",
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                              color: "#606266",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-down el-icon-delete data-area-clear",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clearData(
                                                              "xaxisExt"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "draggable",
                                                    {
                                                      staticClass:
                                                        "drag-block-style",
                                                      attrs: {
                                                        group: "drag",
                                                        animation: "300",
                                                        move: _vm.onMove,
                                                      },
                                                      on: {
                                                        add: _vm.addXaxisExt,
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.calcData(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.view.xaxisExt,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.view,
                                                            "xaxisExt",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "view.xaxisExt",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticClass:
                                                            "draggable-group",
                                                        },
                                                        _vm._l(
                                                          _vm.view.xaxisExt,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "dimension-ext-item",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  param:
                                                                    _vm.param,
                                                                  index: index,
                                                                  item: item,
                                                                  "dimension-data":
                                                                    _vm.dimension,
                                                                  "quota-data":
                                                                    _vm.quota,
                                                                  chart:
                                                                    _vm.chart,
                                                                },
                                                                on: {
                                                                  onDimensionItemChange:
                                                                    _vm.dimensionItemChange,
                                                                  onDimensionItemRemove:
                                                                    _vm.dimensionItemRemove,
                                                                  editItemFilter:
                                                                    _vm.showDimensionEditFilter,
                                                                  onNameEdit:
                                                                    _vm.showRename,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.view.xaxisExt ||
                                                  _vm.view.xaxisExt.length === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "drag-placeholder-style-span",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "chart.placeholder_field"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.view.type !== "table-info" &&
                                          _vm.view.type !== "label"
                                            ? _c(
                                                "el-row",
                                                {
                                                  staticClass: "padding-lr",
                                                  staticStyle: {
                                                    "margin-top": "6px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "data-area-label",
                                                    },
                                                    [
                                                      _vm.view.type &&
                                                      _vm.view.type.includes(
                                                        "table"
                                                      )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_table_data_column"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          (_vm.view.type.includes(
                                                            "bar"
                                                          ) ||
                                                            _vm.view.type.includes(
                                                              "line"
                                                            ) ||
                                                            _vm.view.type.includes(
                                                              "scatter"
                                                            ) ||
                                                            _vm.view.type ===
                                                              "waterfall" ||
                                                            _vm.view.type ===
                                                              "area")
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_value_axis"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "pie"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_pie_angel"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "funnel"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_funnel_width"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "radar"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_radar_length"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "gauge"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_gauge_angel"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "text"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_label_value"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type ===
                                                            "map"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.chart_data"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type.includes(
                                                            "tree"
                                                          )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_treemap_size"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type ===
                                                            "chart-mix"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_value_axis_main"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type ===
                                                            "liquid"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_progress"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.view.type &&
                                                          _vm.view.type ===
                                                            "word-cloud"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "chart.drag_block_word_cloud_size"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.view
                                                                  .type !==
                                                                "richTextView",
                                                              expression:
                                                                "view.type !== 'richTextView'",
                                                            },
                                                          ],
                                                        },
                                                        [_vm._v(" / ")]
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.quota"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-down el-icon-delete data-area-clear",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clearData(
                                                              "yaxis"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "draggable",
                                                    {
                                                      staticClass:
                                                        "drag-block-style",
                                                      attrs: {
                                                        group: "drag",
                                                        animation: "300",
                                                        move: _vm.onMove,
                                                      },
                                                      on: {
                                                        add: _vm.addYaxis,
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.calcData(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: _vm.view.yaxis,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.view,
                                                            "yaxis",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "view.yaxis",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticClass:
                                                            "draggable-group",
                                                        },
                                                        _vm._l(
                                                          _vm.view.yaxis,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "quota-item",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  param:
                                                                    _vm.param,
                                                                  index: index,
                                                                  item: item,
                                                                  chart:
                                                                    _vm.chart,
                                                                  "dimension-data":
                                                                    _vm.dimension,
                                                                  "quota-data":
                                                                    _vm.quota,
                                                                },
                                                                on: {
                                                                  onQuotaItemChange:
                                                                    _vm.quotaItemChange,
                                                                  onQuotaItemRemove:
                                                                    _vm.quotaItemRemove,
                                                                  editItemFilter:
                                                                    _vm.showQuotaEditFilter,
                                                                  onNameEdit:
                                                                    _vm.showRename,
                                                                  editItemCompare:
                                                                    _vm.showQuotaEditCompare,
                                                                  valueFormatter:
                                                                    _vm.valueFormatter,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.view.yaxis ||
                                                  _vm.view.yaxis.length === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "drag-placeholder-style-span",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "chart.placeholder_field"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.view.type &&
                                          _vm.view.type === "chart-mix"
                                            ? _c(
                                                "el-row",
                                                {
                                                  staticClass: "padding-lr",
                                                  staticStyle: {
                                                    "margin-top": "6px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "data-area-label",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.drag_block_value_axis_ext"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        "\n                      /\n                      "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.quota"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-down el-icon-delete data-area-clear",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clearData(
                                                              "yaxisExt"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "draggable",
                                                    {
                                                      staticClass:
                                                        "drag-block-style",
                                                      attrs: {
                                                        group: "drag",
                                                        animation: "300",
                                                        move: _vm.onMove,
                                                      },
                                                      on: {
                                                        add: _vm.addYaxisExt,
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.calcData(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.view.yaxisExt,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.view,
                                                            "yaxisExt",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "view.yaxisExt",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticClass:
                                                            "draggable-group",
                                                        },
                                                        _vm._l(
                                                          _vm.view.yaxisExt,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "quota-ext-item",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  param:
                                                                    _vm.param,
                                                                  index: index,
                                                                  item: item,
                                                                  chart:
                                                                    _vm.chart,
                                                                  "dimension-data":
                                                                    _vm.dimension,
                                                                  "quota-data":
                                                                    _vm.quota,
                                                                },
                                                                on: {
                                                                  onQuotaItemChange:
                                                                    _vm.quotaItemChange,
                                                                  onQuotaItemRemove:
                                                                    _vm.quotaItemRemove,
                                                                  editItemFilter:
                                                                    _vm.showQuotaEditFilter,
                                                                  onNameEdit:
                                                                    _vm.showRename,
                                                                  editItemCompare:
                                                                    _vm.showQuotaEditCompare,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.view.yaxisExt ||
                                                  _vm.view.yaxisExt.length === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "drag-placeholder-style-span",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "chart.placeholder_field"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.view.type &&
                                          _vm.view.type.includes("stack")
                                            ? _c(
                                                "el-row",
                                                {
                                                  staticClass: "padding-lr",
                                                  staticStyle: {
                                                    "margin-top": "6px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "data-area-label",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.stack_item"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        "\n                      /\n                      "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.dimension"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-down el-icon-delete data-area-clear",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clearData(
                                                              "extStack"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "draggable",
                                                    {
                                                      staticClass:
                                                        "drag-block-style",
                                                      attrs: {
                                                        group: "drag",
                                                        animation: "300",
                                                        move: _vm.onMove,
                                                      },
                                                      on: {
                                                        add: _vm.addStack,
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.calcData(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.view.extStack,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.view,
                                                            "extStack",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "view.extStack",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticClass:
                                                            "draggable-group",
                                                        },
                                                        _vm._l(
                                                          _vm.view.extStack,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "chart-drag-item",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  conf: "sort",
                                                                  param:
                                                                    _vm.param,
                                                                  index: index,
                                                                  item: item,
                                                                  "dimension-data":
                                                                    _vm.dimension,
                                                                  "quota-data":
                                                                    _vm.quota,
                                                                },
                                                                on: {
                                                                  onItemChange:
                                                                    _vm.stackItemChange,
                                                                  onItemRemove:
                                                                    _vm.stackItemRemove,
                                                                  onItemCustomSort:
                                                                    _vm.stackItemCustomSort,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.view.extStack ||
                                                  _vm.view.extStack.length === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "drag-placeholder-style-span",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "chart.placeholder_field"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.view.type &&
                                          _vm.view.type.includes("scatter")
                                            ? _c(
                                                "el-row",
                                                {
                                                  staticClass: "padding-lr",
                                                  staticStyle: {
                                                    "margin-top": "6px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "data-area-label",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.bubble_size"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        "\n                      /\n                      "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.quota"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            placement: "bottom",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "content",
                                                              },
                                                              slot: "content",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "chart.scatter_tip"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-info",
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                              color: "#606266",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-down el-icon-delete data-area-clear",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clearData(
                                                              "extBubble"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "draggable",
                                                    {
                                                      staticClass:
                                                        "drag-block-style",
                                                      attrs: {
                                                        group: "drag",
                                                        animation: "300",
                                                        move: _vm.onMove,
                                                      },
                                                      on: {
                                                        add: _vm.addBubble,
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.calcData(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.view.extBubble,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.view,
                                                            "extBubble",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "view.extBubble",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticClass:
                                                            "draggable-group",
                                                        },
                                                        _vm._l(
                                                          _vm.view.extBubble,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "chart-drag-item",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  conf: "summary",
                                                                  param:
                                                                    _vm.param,
                                                                  index: index,
                                                                  item: item,
                                                                  "dimension-data":
                                                                    _vm.dimension,
                                                                  "quota-data":
                                                                    _vm.quota,
                                                                },
                                                                on: {
                                                                  onItemChange:
                                                                    _vm.bubbleItemChange,
                                                                  onItemRemove:
                                                                    _vm.bubbleItemRemove,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.view.extBubble ||
                                                  _vm.view.extBubble.length ===
                                                    0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "drag-placeholder-style-span",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "chart.placeholder_field"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.view.type === "map"
                                            ? _c("mark-map-data-editor", {
                                                attrs: {
                                                  view: _vm.view,
                                                  param: _vm.param,
                                                  "dimension-data":
                                                    _vm.dimension,
                                                  "quota-data": _vm.quota,
                                                },
                                                on: {
                                                  "clear-data": _vm.clearData,
                                                  "calc-data": _vm.calcData,
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "el-row",
                                            {
                                              staticClass: "padding-lr",
                                              staticStyle: {
                                                "margin-top": "6px",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "chart.result_filter"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c(
                                                "draggable",
                                                {
                                                  staticClass:
                                                    "theme-item-class",
                                                  staticStyle: {
                                                    padding: "2px 0 0 0",
                                                    width: "100%",
                                                    "min-height": "32px",
                                                    "border-radius": "4px",
                                                    border: "1px solid #DCDFE6",
                                                    "overflow-x": "auto",
                                                    display: "flex",
                                                    "align-items": "center",
                                                    "background-color": "white",
                                                  },
                                                  attrs: {
                                                    group: "drag",
                                                    animation: "300",
                                                    move: _vm.onMove,
                                                  },
                                                  on: {
                                                    add: _vm.addCustomFilter,
                                                    update: function ($event) {
                                                      return _vm.calcData(true)
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.view.customFilter,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.view,
                                                        "customFilter",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "view.customFilter",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "transition-group",
                                                    {
                                                      staticClass:
                                                        "draggable-group",
                                                    },
                                                    _vm._l(
                                                      _vm.view.customFilter,
                                                      function (item, index) {
                                                        return _c(
                                                          "filter-item",
                                                          {
                                                            key: item.id,
                                                            attrs: {
                                                              param: _vm.param,
                                                              index: index,
                                                              item: item,
                                                              "dimension-data":
                                                                _vm.dimension,
                                                              "quota-data":
                                                                _vm.quota,
                                                            },
                                                            on: {
                                                              onFilterItemRemove:
                                                                _vm.filterItemRemove,
                                                              editItemFilter:
                                                                _vm.showEditFilter,
                                                            },
                                                          }
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              !_vm.view.customFilter ||
                                              _vm.view.customFilter.length === 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "drag-placeholder-style",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style-span",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "chart.placeholder_field"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm.view.type &&
                                          !(
                                            _vm.view.type.includes("table") &&
                                            _vm.view.render === "echarts"
                                          ) &&
                                          !_vm.view.type.includes("text") &&
                                          !_vm.view.type.includes("gauge") &&
                                          _vm.view.type !== "liquid" &&
                                          _vm.view.type !== "word-cloud" &&
                                          _vm.view.type !== "table-pivot" &&
                                          _vm.view.type !== "label" &&
                                          _vm.view.type !== "richTextView"
                                            ? _c(
                                                "el-row",
                                                {
                                                  staticClass: "padding-lr",
                                                  staticStyle: {
                                                    "margin-top": "6px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        width: "80px",
                                                        "text-align": "right",
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.drill"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        "\n                      /\n                      "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chart.dimension"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            placement: "bottom",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "content",
                                                              },
                                                              slot: "content",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "chart.drill_dimension_tip"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-info",
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                              color: "#606266",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "draggable",
                                                    {
                                                      staticClass:
                                                        "drag-block-style",
                                                      attrs: {
                                                        group: "drag",
                                                        animation: "300",
                                                        move: _vm.onMove,
                                                      },
                                                      on: {
                                                        add: _vm.addDrill,
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.calcData(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.view.drillFields,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.view,
                                                            "drillFields",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "view.drillFields",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticClass:
                                                            "draggable-group",
                                                        },
                                                        _vm._l(
                                                          _vm.view.drillFields,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "drill-item",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  param:
                                                                    _vm.param,
                                                                  index: index,
                                                                  item: item,
                                                                  "dimension-data":
                                                                    _vm.dimension,
                                                                  "quota-data":
                                                                    _vm.quota,
                                                                },
                                                                on: {
                                                                  onDimensionItemChange:
                                                                    _vm.drillItemChange,
                                                                  onDimensionItemRemove:
                                                                    _vm.drillItemRemove,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.view.drillFields ||
                                                  _vm.view.drillFields
                                                    .length === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "drag-placeholder-style",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "drag-placeholder-style-span",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "chart.placeholder_field"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  staticClass: "padding-tab",
                  staticStyle: { width: "350px" },
                  attrs: { name: "style", label: _vm.$t("chart.chart_style") },
                },
                [
                  _vm.chartProperties || _vm.view.isPlugin
                    ? _c("chart-style", {
                        attrs: {
                          param: _vm.param,
                          view: _vm.view,
                          chart: _vm.chart,
                          properties: _vm.chartProperties,
                          "property-inner-all": _vm.chartPropertyInnerAll,
                          "dimension-data": _vm.dimensionData,
                          "quota-data": _vm.quotaData,
                        },
                        on: {
                          calcStyle: _vm.calcStyle,
                          onColorChange: _vm.onColorChange,
                          onSizeChange: _vm.onSizeChange,
                          onLabelChange: _vm.onLabelChange,
                          onTooltipChange: _vm.onTooltipChange,
                          onTotalCfgChange: _vm.onTotalCfgChange,
                          onChangeXAxisForm: _vm.onChangeXAxisForm,
                          onChangeYAxisForm: _vm.onChangeYAxisForm,
                          onChangeYAxisExtForm: _vm.onChangeYAxisExtForm,
                          onChangeSplitForm: _vm.onChangeSplitForm,
                          onTextChange: _vm.onTextChange,
                          onLegendChange: _vm.onLegendChange,
                          onMarginChange: _vm.onMarginChange,
                          onChangeBackgroundForm: _vm.onChangeBackgroundForm,
                          onSuspensionChange: _vm.onSuspensionChange,
                          onMarkChange: _vm.onMarkChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  staticClass: "padding-tab",
                  staticStyle: { width: "350px" },
                  attrs: { name: "senior", label: _vm.$t("chart.senior") },
                },
                [
                  _c("el-row", { staticClass: "view-panel" }, [
                    _vm.view.type &&
                    (_vm.view.type.includes("bar") ||
                      _vm.view.type.includes("line") ||
                      _vm.view.type.includes("area") ||
                      _vm.view.type.includes("mix") ||
                      _vm.view.type.includes("gauge") ||
                      _vm.view.type === "text" ||
                      _vm.view.type === "label" ||
                      _vm.view.type.includes("table") ||
                      _vm.view.type === "map" ||
                      _vm.view.type === "buddle-map")
                      ? _c(
                          "div",
                          {
                            staticClass: "attr-style theme-border-class",
                            staticStyle: {
                              overflow: "auto",
                              "border-right": "1px solid #e6e6e6",
                              height: "100%",
                              width: "100%",
                            },
                          },
                          [
                            _vm.view.type &&
                            (_vm.view.type.includes("bar") ||
                              _vm.view.type.includes("line") ||
                              _vm.view.type.includes("area") ||
                              _vm.view.type.includes("mix") ||
                              _vm.view.type === "table-normal" ||
                              _vm.view.type === "table-info")
                              ? _c(
                                  "el-row",
                                  [
                                    _c("span", { staticClass: "padding-lr" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.senior_cfg"))
                                      ),
                                    ]),
                                    _c(
                                      "el-collapse",
                                      {
                                        staticClass: "style-collapse",
                                        model: {
                                          value: _vm.attrActiveNames,
                                          callback: function ($$v) {
                                            _vm.attrActiveNames = $$v
                                          },
                                          expression: "attrActiveNames",
                                        },
                                      },
                                      [
                                        _vm.view.type &&
                                        (_vm.view.type.includes("bar") ||
                                          _vm.view.type.includes("line") ||
                                          _vm.view.type.includes("area") ||
                                          _vm.view.type.includes("mix"))
                                          ? _c(
                                              "el-collapse-item",
                                              {
                                                attrs: {
                                                  name: "function",
                                                  title:
                                                    _vm.$t(
                                                      "chart.function_cfg"
                                                    ),
                                                },
                                              },
                                              [
                                                _c("function-cfg", {
                                                  staticClass: "attr-selector",
                                                  attrs: {
                                                    param: _vm.param,
                                                    chart: _vm.chart,
                                                  },
                                                  on: {
                                                    onFunctionCfgChange:
                                                      _vm.onFunctionCfgChange,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.view.type &&
                                        (_vm.view.type === "table-normal" ||
                                          _vm.view.type === "table-info")
                                          ? _c(
                                              "el-collapse-item",
                                              {
                                                attrs: {
                                                  name: "scroll",
                                                  title:
                                                    _vm.$t("chart.scroll_cfg"),
                                                },
                                              },
                                              [
                                                _c("scroll-cfg", {
                                                  staticClass: "attr-selector",
                                                  attrs: {
                                                    param: _vm.param,
                                                    chart: _vm.chart,
                                                  },
                                                  on: {
                                                    onScrollCfgChange:
                                                      _vm.onScrollChange,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.view.type &&
                            (_vm.view.type.includes("bar") ||
                              _vm.view.type.includes("line") ||
                              _vm.view.type.includes("area") ||
                              _vm.view.type.includes("mix") ||
                              _vm.view.type.includes("gauge") ||
                              _vm.view.type === "text" ||
                              _vm.view.type === "label" ||
                              (_vm.view.render === "antv" &&
                                _vm.view.type.includes("table")))
                              ? _c(
                                  "el-row",
                                  [
                                    _c("span", { staticClass: "padding-lr" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.analyse_cfg"))
                                      ),
                                    ]),
                                    _c(
                                      "el-collapse",
                                      {
                                        staticClass: "style-collapse",
                                        model: {
                                          value: _vm.styleActiveNames,
                                          callback: function ($$v) {
                                            _vm.styleActiveNames = $$v
                                          },
                                          expression: "styleActiveNames",
                                        },
                                      },
                                      [
                                        _vm.view.type &&
                                        (_vm.view.type.includes("bar") ||
                                          _vm.view.type.includes("line") ||
                                          _vm.view.type.includes("area") ||
                                          _vm.view.type.includes("mix"))
                                          ? _c(
                                              "el-collapse-item",
                                              {
                                                attrs: {
                                                  name: "analyse",
                                                  title:
                                                    _vm.$t("chart.assist_line"),
                                                },
                                              },
                                              [
                                                _c("assist-line", {
                                                  staticClass: "attr-selector",
                                                  attrs: {
                                                    param: _vm.param,
                                                    chart: _vm.chart,
                                                    "quota-data":
                                                      _vm.view.yaxis,
                                                  },
                                                  on: {
                                                    onAssistLineChange:
                                                      _vm.onAssistLineChange,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.view.type &&
                                        (_vm.view.type.includes("gauge") ||
                                          _vm.view.type === "text" ||
                                          _vm.view.type === "label" ||
                                          (_vm.view.render === "antv" &&
                                            _vm.view.type.includes("table")))
                                          ? _c(
                                              "el-collapse-item",
                                              {
                                                attrs: {
                                                  name: "threshold",
                                                  title:
                                                    _vm.$t("chart.threshold"),
                                                },
                                              },
                                              [
                                                _c("threshold", {
                                                  staticClass: "attr-selector",
                                                  attrs: {
                                                    param: _vm.param,
                                                    chart: _vm.chart,
                                                  },
                                                  on: {
                                                    onThresholdChange:
                                                      _vm.onThresholdChange,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.view.type &&
                            (_vm.view.type === "map" ||
                              _vm.view.type === "buddle-map")
                              ? _c(
                                  "el-row",
                                  [
                                    false
                                      ? _c(
                                          "span",
                                          { staticClass: "padding-lr" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("chart.senior_cfg"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-collapse",
                                      {
                                        staticClass: "style-collapse",
                                        model: {
                                          value: _vm.mapActiveNames,
                                          callback: function ($$v) {
                                            _vm.mapActiveNames = $$v
                                          },
                                          expression: "mapActiveNames",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-collapse-item",
                                          {
                                            attrs: {
                                              title: _vm.$t(
                                                "chart.place_name_mapping"
                                              ),
                                              name: "map-mapping",
                                            },
                                          },
                                          [
                                            _c("map-mapping", {
                                              staticClass: "attr-selector",
                                              attrs: {
                                                param: _vm.param,
                                                chart: _vm.chart,
                                                "dynamic-area-code":
                                                  _vm.currentAreaCode,
                                              },
                                              on: {
                                                onMapMappingChange:
                                                  _vm.onMapMappingChange,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "no-senior" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("chart.chart_no_senior")) +
                              "\n          "
                          ),
                        ]),
                  ]),
                ],
                1
              ),
              !_vm.curComponent.auxiliaryMatrix
                ? _c(
                    "el-tab-pane",
                    {
                      staticClass: "padding-tab",
                      staticStyle: { width: "350px" },
                      attrs: {
                        name: "position",
                        label: _vm.$t("panel.position_adjust"),
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "attr-style theme-border-class" },
                        [
                          _c(
                            "el-collapse",
                            {
                              staticClass: "style-collapse",
                              model: {
                                value: _vm.positionActiveNames,
                                callback: function ($$v) {
                                  _vm.positionActiveNames = $$v
                                },
                                expression: "positionActiveNames",
                              },
                            },
                            [
                              _c(
                                "el-collapse-item",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "panel.position_adjust_component"
                                    ),
                                    name: "positionAdjust",
                                  },
                                },
                                [_c("position-adjust")],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.editFrom === "view"
            ? _c(
                "el-col",
                {
                  staticStyle: {
                    height: "100%",
                    "min-width": "500px",
                    "border-top": "1px solid #E6E6E6",
                  },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "padding-lr",
                      staticStyle: { width: "100%", height: "100%" },
                    },
                    [
                      _c(
                        "div",
                        {
                          ref: "imageWrapper",
                          staticStyle: { height: "100%" },
                        },
                        [
                          _vm.httpRequest.status &&
                          _vm.chart.type &&
                          _vm.view.isPlugin
                            ? _c("plugin-com", {
                                ref: "dynamicChart",
                                staticClass: "chart-class",
                                attrs: {
                                  "component-name": _vm.chart.type + "-view",
                                  obj: { chart: _vm.chart },
                                  "chart-id": _vm.chart.id,
                                  chart: _vm.chart,
                                  "theme-style":
                                    _vm.curComponent.commonBackground,
                                },
                                on: { onChartClick: _vm.chartClick },
                              })
                            : _vm.httpRequest.status &&
                              _vm.chart.type &&
                              !_vm.chart.type.includes("table") &&
                              !_vm.chart.type.includes("text") &&
                              _vm.chart.type !== "label" &&
                              _vm.renderComponent() === "echarts"
                            ? _c("chart-component", {
                                ref: "dynamicChart",
                                staticClass: "chart-class",
                                attrs: {
                                  "chart-id": _vm.chart.id,
                                  chart: _vm.chart,
                                  "theme-style":
                                    _vm.curComponent.commonBackground,
                                },
                                on: { onChartClick: _vm.chartClick },
                              })
                            : _vm.httpRequest.status &&
                              _vm.chart.type &&
                              !_vm.chart.type.includes("table") &&
                              !_vm.chart.type.includes("text") &&
                              _vm.chart.type !== "label" &&
                              _vm.renderComponent() === "antv"
                            ? _c("chart-component-g2", {
                                ref: "dynamicChart",
                                staticClass: "chart-class",
                                attrs: {
                                  "chart-id": _vm.chart.id,
                                  chart: _vm.chart,
                                },
                                on: { onChartClick: _vm.chartClick },
                              })
                            : _vm.httpRequest.status &&
                              _vm.chart.type &&
                              _vm.chart.type.includes("table") &&
                              !_vm.chart.type.includes("text") &&
                              _vm.chart.type !== "label" &&
                              _vm.renderComponent() === "antv"
                            ? _c("chart-component-s2", {
                                ref: "dynamicChart",
                                staticClass: "chart-class",
                                attrs: {
                                  "chart-id": _vm.chart.id,
                                  chart: _vm.chart,
                                },
                                on: { onChartClick: _vm.chartClick },
                              })
                            : _vm.httpRequest.status &&
                              _vm.chart.type &&
                              _vm.chart.type.includes("table") &&
                              _vm.renderComponent() === "echarts" &&
                              _vm.chart.type !== "table-pivot"
                            ? _c("table-normal", {
                                staticClass: "table-class",
                                attrs: {
                                  "show-summary":
                                    _vm.chart.type === "table-normal",
                                  chart: _vm.chart,
                                },
                              })
                            : _vm.httpRequest.status &&
                              _vm.chart.type &&
                              _vm.chart.type.includes("text")
                            ? _c("label-normal", {
                                staticClass: "table-class",
                                attrs: { chart: _vm.chart },
                              })
                            : _vm.httpRequest.status &&
                              _vm.chart.type &&
                              _vm.chart.type === "label"
                            ? _c("label-normal-text", {
                                staticClass: "table-class",
                                attrs: { chart: _vm.chart },
                              })
                            : _vm._e(),
                          !_vm.httpRequest.status
                            ? _c("div", { staticClass: "chart-error-class" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#9ea6b2",
                                      height: "100%",
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "center",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.httpRequest.msg) +
                                        "," +
                                        _vm._s(
                                          _vm.$t("chart.chart_show_error")
                                        ) +
                                        "\n              "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("chart.chart_error_tips")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "absolute",
                            left: "8px",
                            bottom: "8px",
                          },
                        },
                        [
                          _c("drill-path", {
                            attrs: { "drill-filters": _vm.drillFilters },
                            on: { onDrillJump: _vm.drillJump },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.$t("chart.show_name_set"),
            visible: _vm.renameItem,
            "show-close": false,
            width: "30%",
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "itemForm",
              attrs: {
                "label-width": "80px",
                model: _vm.itemForm,
                rules: _vm.itemFormRules,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("dataset.field_origin_name") },
                },
                [
                  _c("span", { staticStyle: { padding: "0 16px" } }, [
                    _vm._v(_vm._s(_vm.itemForm.dsFieldName)),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show_name") },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { size: "mini", clearable: "" },
                    model: {
                      value: _vm.itemForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemForm, "name", $$v)
                      },
                      expression: "itemForm.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.closeRename()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.saveRename },
                },
                [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.quotaFilterEdit
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.add_filter"),
                visible: _vm.quotaFilterEdit,
                "show-close": false,
                width: "800px",
              },
            },
            [
              _c("quota-filter-editor", { attrs: { item: _vm.quotaItem } }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeQuotaFilter },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveQuotaFilter },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.dimensionFilterEdit
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.add_filter"),
                visible: _vm.dimensionFilterEdit,
                "show-close": false,
                width: "800px",
              },
            },
            [
              _c("dimension-filter-editor", {
                attrs: { item: _vm.dimensionItem },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeDimensionFilter },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveDimensionFilter },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.resultFilterEdit
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.add_filter"),
                visible: _vm.resultFilterEdit,
                "show-close": false,
                width: "800px",
              },
            },
            [
              _c("result-filter-editor", {
                attrs: { chart: _vm.chartForFilter, item: _vm.filterItem },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeResultFilter },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveResultFilter },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.selectTableFlag
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.changeDsTitle,
                visible: _vm.selectTableFlag,
                "show-close": false,
                width: "70%",
              },
            },
            [
              _c("table-selector", {
                attrs: { "checked-table": _vm.table },
                on: { getTable: _vm.getTable },
              }),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    color: "#F56C6C",
                    "font-size": "12px",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("chart.change_ds_tip")))]
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeChangeChart },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled: !_vm.changeTable || !_vm.changeTable.id,
                      },
                      on: { click: _vm.changeChart },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("chart.confirm")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.editDsField
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog-css",
              attrs: {
                visible: _vm.editDsField,
                "show-close": false,
                fullscreen: true,
              },
            },
            [
              _c("field-edit", {
                attrs: { param: _vm.table, table: _vm.table },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer title-text",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("chart.ds_field_edit")) +
                        "\n        "
                    ),
                    _vm.table
                      ? _c("span", [_vm._v("[" + _vm._s(_vm.table.name) + "]")])
                      : _vm._e(),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { size: "mini" },
                      on: { click: _vm.closeEditDsField },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.close")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showEditChartField
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog-css",
              attrs: {
                visible: _vm.showEditChartField,
                "show-close": false,
                fullscreen: true,
              },
            },
            [
              _c("chart-field-edit", {
                attrs: { param: _vm.chart, table: _vm.table, chart: _vm.chart },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer title-text",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("chart.chart_field_edit")) +
                        "\n        "
                    ),
                    _vm.table
                      ? _c("span", [
                          _vm._v("[" + _vm._s(_vm.chart.title) + "]"),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { size: "mini" },
                      on: { click: _vm.closeEditChartField },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.close")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showEditQuotaCompare
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.yoy_setting"),
                visible: _vm.showEditQuotaCompare,
                "show-close": false,
                width: "600px",
              },
            },
            [
              _c("compare-edit", {
                attrs: {
                  "compare-item": _vm.quotaItemCompare,
                  chart: _vm.chart,
                },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeQuotaEditCompare },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveQuotaEditCompare },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showValueFormatter
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title:
                  _vm.$t("chart.value_formatter") +
                  " - " +
                  _vm.valueFormatterItem.name,
                visible: _vm.showValueFormatter,
                "show-close": false,
                width: "600px",
              },
            },
            [
              _c("value-formatter-edit", {
                attrs: {
                  "formatter-item": _vm.valueFormatterItem,
                  chart: _vm.chart,
                },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeValueFormatter },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveValueFormatter },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showCustomSort
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.custom_sort"),
                visible: _vm.showCustomSort,
                "show-close": false,
                width: "500px",
              },
            },
            [
              _c("custom-sort-edit", {
                attrs: {
                  chart: _vm.chart,
                  "field-type": "xAxis",
                  field: _vm.customSortField,
                },
                on: { onSortChange: _vm.customSortChange },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeCustomSort },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveCustomSort },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showStackCustomSort
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.custom_sort"),
                visible: _vm.showStackCustomSort,
                "show-close": false,
                width: "500px",
              },
            },
            [
              _c("custom-sort-edit", {
                attrs: {
                  chart: _vm.chart,
                  "field-type": "extStack",
                  field: _vm.customSortField,
                },
                on: { onSortChange: _vm.customSortChange },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeStackCustomSort },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveStackCustomSort },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.editChartCalcField
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                visible: _vm.editChartCalcField,
                "show-close": false,
                title: _vm.$t("chart.copy_field"),
                "append-to-body": "",
              },
            },
            [
              _c("calc-chart-field-edit", {
                attrs: {
                  param: _vm.chart,
                  field: _vm.currEditField,
                  mode: _vm.currEditField.extField === 1 ? "copy" : "normal",
                },
                on: { onEditClose: _vm.closeChartCalcField },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }